module.exports = __webpack_public_path__ + "static/media/sura-checkmark.4d38e84a.svg";